import { useI18nTranslation } from '@idmc-ms-fabric/common';

import { TI18nKeys } from '../i18n/i18nKeys';

/**
 * Alias method with key type set to i18n keys.
 */
const useDQTranslation = useI18nTranslation<TI18nKeys>;
export default useDQTranslation;
